/**
 * Custom error codes and keys used in the application.
 */

import {
	ELASTIC_SEARCH_INVALID_COOKIE_KEY,
	ERR_AUTHENTICATION_COOKIE_NOT_IN_HTTPS_CODE,
	ERR_AUTHENTICATION_COOKIE_NOT_IN_HTTPS_KEY,
	GENERIC_USER_ERROR,
	INVALID_COOKIE_ERROR_CODE,
	INVALID_COOKIE_ERROR_KEY,
} from '@/core/data/constants/errors';
export const INTERNAL_SERVER_ERROR = 'CWXFR0230E';
export const ERR_REMOTE_EXCEPTION = 'CMN0412E';
export const COOKIE_ERRORS: Record<string, string> = {
	[INVALID_COOKIE_ERROR_KEY]: INVALID_COOKIE_ERROR_KEY,
	[INVALID_COOKIE_ERROR_CODE]: INVALID_COOKIE_ERROR_CODE,
	[ELASTIC_SEARCH_INVALID_COOKIE_KEY]: ELASTIC_SEARCH_INVALID_COOKIE_KEY,
	[ERR_AUTHENTICATION_COOKIE_NOT_IN_HTTPS_CODE]: ERR_AUTHENTICATION_COOKIE_NOT_IN_HTTPS_CODE,
	[ERR_AUTHENTICATION_COOKIE_NOT_IN_HTTPS_KEY]: ERR_AUTHENTICATION_COOKIE_NOT_IN_HTTPS_KEY,
	[GENERIC_USER_ERROR]: GENERIC_USER_ERROR,
};
export * from '@/core/data/constants/errors';
